import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/api-response.model';
import { ItemLogDto } from '../models/item-log-dto';
import { BaseService } from './base-service';

@Injectable({
  providedIn: 'root',
})
export class ItemLogService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }
  
  getItemLogs(id: string): Observable<ApiResponse<ItemLogDto[]>> {
    return this.http.get<ApiResponse<ItemLogDto[]>>(
      'ItemLog/GetItemLogs/' + id
    );
  }

}




